import { Alert } from "reactstrap";
import { Field } from "formik";

import RowInput from "../../FormElements/RowInput";

export const OrganizationForm = ({
  defaultValues,
  translate,
  organizationData,
  isUpdateProcess = false,
}) => {
  const isExternal = organizationData?.isExternal;
  const isDisabled =
    defaultValues?.isDisabled || (organizationData && !isExternal);

  const fields = [
    {
      label: translate("organizationDescription"),
      name: "organization.description",
    },
    {
      label: translate("organizationLongDescription"),
      name: "organization.longDescription",
    },
    {
      label: translate("legalRepresentativeName"),
      name: "organization.legalRepresentativeName",
    },
    {
      label: translate("legalRepresentativeSurname"),
      name: "organization.legalRepresentativeSurname",
    },
  ];

  return (
    <>
      {!organizationData && !isUpdateProcess && (
        <Alert color="warning" className="mt-2">
          {translate("createOrganization")}
        </Alert>
      )}

      {fields.map(({ label, name, alwaysEnable }) => (
        <Field
          key={name}
          label={label}
          name={name}
          component={RowInput}
          disabled={!alwaysEnable && isDisabled}
        />
      ))}
    </>
  );
};
